module.exports = __webpack_public_path__ + "img/MKD.8d7c8ece.svg";